import type {
  IReason,
  IReasons,
  ActionType,
  ParticipantType,
} from '../types/IReasons';
import type {IRootMachineSnapshot} from '../machines/rootMachine/rootMachine';


export const selectReasonsByParticipantTypeAndActionType = (
  state: IRootMachineSnapshot,
  participantType: ParticipantType,
  actionType: ActionType,
): IReasons => {
  const normalisedParticipantType: ParticipantType =
    participantType === 'INTERVIEWER' ? 'HOST' : participantType;
  const reasons =
    (state.context.reasons || []).filter(
      (reason: IReason) =>
        reason.participant_type === normalisedParticipantType &&
        reason.action_type === actionType,
    ) || [];

  if (reasons.length > 0) {
    reasons.push({
      id: '1',
      reason: 'My reason is not listed here',
      participant_type: normalisedParticipantType,
      action_type: actionType,
    });
  }
  return reasons;
};
